export enum WEB_MENU_ITEMS {
  APPOINTMENTS_SCHEDULING = 'appointmentsScheduling',
  ASSIGNMENTS = 'assignments',
  CLASSMATES = 'classmates',
  CONTACT = 'contact',
  COURSE = 'course',
  DOCUMENTS = 'documents',
  EXAMS = 'exams',
  FAQ = 'faq',
  GUIDE = 'guide',
  HOME = 'home',
  INTERNSHIPS = 'internships',
  LEARNING_RESOURCES = 'learningResources',
  NEWS = 'news',
  PROGRESSION = 'progression',
  REVISIONS = 'revisions',
  VIRTUAL_CLASSROOMS = 'virtualClassrooms',
  WORK_STUDY = 'workStudy',
}

export enum WEB_FEATURES {
  CONTACT_TEACHER = 'contact_teacher',
  DOWNLOAD_LESSON = 'download_lesson',
  ASSIGNMENTS = 'assignments',
  PROGRESS_INDICATOR = 'progress_indicator',
  BOOST_CARD = 'boost_card',
  SUBSCRIPTION_CARD = 'subscription_card',
  LIMITED_ACCESS_CARD = 'limited_access_card',
  PENDING_ACCESS_CARD = 'pending_access_card',
  UNLOCK_LESSON = 'unlock_lesson',
  CALENDAR = 'calendar',
  STREAKS_CALENDAR = 'streaks_calendar',
  RECENT_ACHIEVEMENTS = 'recent_achievements',
  LIVE_UPCOMING = 'live_upcoming',
  QUESTS = 'quests',
  VIRTUAL_CLASSROOMS = 'virtual_classrooms',
  EXTERNAL_LESSON_OUT_OF_PROGRESS = 'external_lesson_out_of_progress',
  GOOGLE_AGENDA = 'google_agenda',
  GOOGLE_EMAIL = 'google_email',
  LAST_NEWS = 'last_news',
}

export enum LANGUAGES {
  DEFAULT = 'FRENCH',
  FRENCH = 'FRENCH',
  ENGLISH = 'ENGLISH',
}

export enum THEME_MODES {
  DEFAULT = 'DEFAULT',
  DARK = 'DARK',
}

export enum INTERNSHIPS_OR_WORK_STUDY {
  INTERNSHIPS = 'internships',
  WORK_STUDY = 'workStudy',
  NONE = 'none',
}

export enum WALLET_REFILL_MODES {
  AT_REGISTRATION = 'AT_REGISTRATION',
  ON_DEMAND = 'ON_DEMAND',
  PERIODICALLY = 'PERIODICALLY',
}

export enum MODES {
  DEFAULT = 'DEFAULT',
  DISCOVERY = 'DISCOVERY',
}

export enum SCHOOL_ENTITIES {
  ENACO = 'ENACO',
}
export * from './model';
